module.exports = __webpack_public_path__ + "static/media/census-logo@4x.f1cadc11.png";